import { db } from "../../shared/config";
import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  startAfter,
  endBefore,
  limitToLast,
  limit,
  Timestamp,
  where,
} from "firebase/firestore";
import {
  GET_BENIFICIARYS,
  ADD_BENIFICIARY,
  GET_BENIFICIARY,
  RESET_BENIFICIARY,
  BENIFICIARYS_ERROR,
} from "../types/benificiary_type";

import { setAlert } from "./alert";
import { LIMIT } from "../../domain/constant";
//GET BENIFICIARYS
const benificiarysRef = collection(db, "profiles");
export const getBenificiarys =
  ({ term, termField, orderValue = "createdAt", orderType = "desc" }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(benificiarysRef, where(termField, "==", term));
      } else {
        searchQuery = query(
          benificiarysRef,
          where("profile_type", "==", "beneficiary"),
          orderBy(orderValue, orderType),
          limit(LIMIT)
        );
      }
      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_BENIFICIARYS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: BENIFICIARYS_ERROR,
      });
    }
  };

export const getNextBenificiarys =
  ({ term, termField, last, orderValue = "createdAt", orderType = "desc" }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(
          benificiarysRef,
          where("profile_type", "==", "beneficiary"),
          orderBy(orderValue, orderType),
          startAfter(last[orderValue]),
          limit(LIMIT),
          where(termField, "==", term)
        );
      } else {
        searchQuery = query(
          benificiarysRef,
          orderBy(orderValue, orderType),
          startAfter(last[orderValue]),
          limit(LIMIT)
        );
      }
      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_BENIFICIARYS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: BENIFICIARYS_ERROR,
      });
    }
  };
export const getPreviousBenificiarys =
  ({ term, termField, first, orderValue = "createdAt", orderType = "desc" }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(
          benificiarysRef,
          orderBy(orderValue, orderType),
          endBefore(first[orderValue]),
          limitToLast(LIMIT),
          where(termField, "==", term)
        );
      } else {
        searchQuery = query(
          benificiarysRef,
          orderBy(orderValue, orderType),
          endBefore(first[orderValue]),
          limitToLast(LIMIT)
        );
      }

      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_BENIFICIARYS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: BENIFICIARYS_ERROR,
      });
    }
  };

export const addBenificiary = (data) => async (dispatch) => {
  try {
    data.createdAt = Timestamp.fromDate(new Date());
    const docRef = await addDoc(benificiarysRef, data);
    dispatch({
      type: ADD_BENIFICIARY,
    });
    dispatch(setAlert("Benificiary added successfully", "success"));
  } catch (e) {
    console.error("Error adding document: ", e);
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: BENIFICIARYS_ERROR,
    });
  }
};

export const getBenificiary = (id) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_BENIFICIARY,
    });
    const docRef = doc(db, "profiles", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      data.id = id;
      dispatch({
        type: GET_BENIFICIARY,
        payload: data,
      });
    } else {
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: BENIFICIARYS_ERROR,
      });
    }
  } catch (err) {
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: BENIFICIARYS_ERROR,
    });
  }
};
export const editBenificiary = (id, data) => async (dispatch) => {
  try {
    const docSnap = await updateDoc(doc(db, "profiles", id), data);
    dispatch(setAlert("Benificiary updated successfully", "success"));
  } catch (err) {
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: BENIFICIARYS_ERROR,
    });
  }
};

export const deleteBenificiary = (id) => async (dispatch) => {
  try {
    const docSnap = await deleteDoc(doc(db, "profiles", id));
    dispatch(setAlert("Benificiary deleted successfully", "success"));
  } catch (err) {
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: BENIFICIARYS_ERROR,
    });
  }
};
